export const simNaoNaoInformado = [
  { label: 'Sim' },
  { label: 'Não' },
  { label: 'Não informado' },
];

export const veiculosList = [
  { label: 'Bicicleta' },
  { label: 'Ciclomotor' },
  { label: 'Motocicleta' },
  { label: 'Triciclo' },
  { label: 'Motoneta' },
  { label: 'Automóvel' },
  { label: 'Caminhonete' },
  { label: 'Com Reboque' },
  { label: 'Utilitário' },
  { label: 'Camioneta' },
  { label: 'Caminhão' },
  { label: 'Caminhão Trator' },
  { label: 'Caminhão 2 Eixos' },
  { label: 'Caminhão 3 Eixos' },
  { label: 'Caminhão 4 Eixos' },
  { label: 'Caminhão c/ Semi-Reboque' },
  { label: 'Microônibus' },
  { label: 'Ônibus' },
  { label: 'Trem' },
  { label: 'Tração Animal' },
  { label: 'Trator' },
  { label: 'Outros' },
  { label: 'Não informado' },
];

export const gravidadesList = [
  { label: 'Leve' },
  { label: 'Moderado' },
  { label: 'Grave' },
  { label: 'Fatal' },
  { label: 'Não informado' },
];

export const tipoAcidentesList = [
  { label: 'Colisão' },
  { label: 'Choque c/ Obstáculo Fixo' },
  { label: 'Colisão Transversal' },
  { label: 'Colisão Traseira' },
  { label: 'Colisão Lateral' },
  { label: 'Engavetamento' },
  { label: 'Queda' },
  { label: 'Atropelamento' },
  { label: 'Colisão Frontal' },
  { label: 'Capotamento' },
  { label: 'Colisão Lateral Sentido Oposto' },
  { label: 'Tombamento' },
  { label: 'Atropelamento de Animal' },
  { label: 'Choque' },
  { label: 'Acidente Pessoal' },
  { label: 'Outros' },
  { label: 'Não informado' },
];

export const bairrosList = [
  { label: 'Centro' },
  { label: 'Pici' },
  { label: 'Siqueira' },
  { label: 'Aldeota' },
  { label: 'Papicu' },
  { label: 'Jangurussu' },
];

export const jurisdicaoList = [
  { label: 'Municipal' },
  { label: 'Estadual' },
  { label: 'Federal' },
  { label: 'Não informado' },
];

export const severidade = [
  { label: 'Ileso' },
  { label: 'Ferido' },
  { label: 'Fatal' },
  { label: 'Não informado' },
];

export const elementosAtingidosList = [
  { label: 'Árvore' },
  { label: 'Sinalização' },
  { label: 'Semáforo' },
  { label: 'Poste' },
  { label: 'Publicidade' },
  { label: 'Veículo Estacionado' },
  { label: 'Edificação' },
  { label: 'Nenhum' },
  { label: 'Outros' },
  { label: 'Não informado' },
];

export const viaOuCruzamentoList = [{ label: 'Longo da via' }, { label: 'Cruzamento' }];

export const informacaoFontesList = [
  { label: 'AMCBO' },
  { label: 'BEST' },
  { label: 'PRE' },
  { label: 'PRF' },
  { label: 'SAMU' },
  { label: 'PEFOCE' },
  { label: 'SIM' },
  { label: 'IML' },
  { label: 'Não informado' },
];

export const iluminacaoList = [
  { label: 'Amanhecer' },
  { label: 'Luz do Dia' },
  { label: 'Anoitecer' },
  { label: 'Via Iluminada' },
  { label: 'Mal Iluminada' },
  { label: 'Não Iluminada' },
  { label: 'Não informado' },
];

export const tempoList = [
  { label: 'Bom' },
  { label: 'Nublado' },
  { label: 'Chuva' },
  { label: 'Outros' },
  { label: 'Não informado' },
];

export const localList = [
  { label: 'Escola' },
  { label: 'Lazer' },
  { label: 'Residencial' },
  { label: 'Comercial' },
  { label: 'Industrial' },
  { label: 'Rural' },
  { label: 'Misto' },
  { label: 'Outros' },
  { label: 'Não informado' },
];

export const superficiePistaList = [
  { label: 'Seca' },
  { label: 'Molhada' },
  { label: 'Material Derrapante' },
  { label: 'Inundada' },
  { label: 'Outros' },
  { label: 'Não informado' },
];

export const tipoCruzamento = [
  { label: 'Cruz' },
  { label: 'T' },
  { label: 'Duplo T' },
  { label: 'Y' },
  { label: 'Rotatória' },
  { label: 'Com via férrea' },
  { label: 'Meio de quadra' },
  { label: 'Outros' },
  { label: 'Não informado' },
];

export const controleTrafegoList = [
  { label: 'Gesto' },
  { label: 'Pare' },
  { label: 'Cancela' },
  { label: 'Cancela Danificada' },
  { label: 'Semáforo' },
  { label: 'Semáforo Danificado' },
  { label: 'Semáforo Manual' },
  { label: 'Semáforo Intermitente' },
  { label: 'Dê Preferência' },
  { label: 'Faixa de Pedestre' },
  { label: 'Não há Controle' },
  { label: 'Outros' },
  { label: 'Não informado' },
];

export const sinalizacaoHorizontalList = [
  { label: 'Bom estado' },
  { label: 'Visibilidade ruim' },
  { label: 'Condição ruim' },
  { label: 'Não há' },
  { label: 'Não informado' },
];

export const sinalizacaoVerticalList = [
  { label: 'Bom estado' },
  { label: 'Visibilidade ruim' },
  { label: 'Em má condição' },
  { label: 'Não há' },
  { label: 'Não informado' },
];

export const alinhamentoHorizontalList = [
  { label: 'Interseção' },
  { label: 'Curvo' },
  { label: 'Reto' },
  { label: 'Não informado' },
];

export const alinhamentoVerticalList = [
  { label: 'Plano' },
  { label: 'Rampa ascendente' },
  { label: 'Rampa descendente' },
  { label: 'Lombada' },
  { label: 'Depressão' },
  { label: 'Outros' },
  { label: 'Não informado' },
];

export const obraDeArteList = [
  { label: 'Ponte' },
  { label: 'Viaduto' },
  { label: 'Túnel' },
  { label: 'Passarela' },
  { label: 'Não há' },
  { label: 'Não informado' },
];

export const obrasNaPistaList = [
  { label: 'Sinalizada' },
  { label: 'Mal sinalizada' },
  { label: 'Não sinalizada' },
  { label: 'Não há' },
  { label: 'Não informado' },
];

export const tipoPistaList = [
  { label: 'Simples' },
  { label: 'Dupla' },
  { label: 'Múltipla' },
  { label: 'Não informado' },
];

export const tipoPavimentoList = [
  { label: 'Asfalto' },
  { label: 'Concreto' },
  { label: 'Paralelepípedo' },
  { label: 'Pedra tosca' },
  { label: 'Cascalho/terra' },
  { label: 'Outro' },
  { label: 'Não informado' },
];

export const faixaSentidoList = [
  { label: 'Uma' },
  { label: 'Duas' },
  { label: 'Três' },
  { label: 'Mais de três' },
  { label: 'Não informado' },
];

export const condicaoPistaList = [
  { label: 'Boa' },
  { label: 'Em obras' },
  { label: 'Buracos' },
  { label: 'Depressão' },
  { label: 'Lombada' },
  { label: 'Outros' },
  { label: 'Não informado' },
];

export const condicaoCalcadaList = [
  { label: 'Boa' },
  { label: 'Má' },
  { label: 'Obstruída' },
  { label: 'Não há' },
  { label: 'Não informado' },
];

export const separacaoCentralList = [
  { label: 'Pintura' },
  { label: 'Tachão/tartaruga' },
  { label: 'Prisma concreto' },
  { label: 'Canteiro elevado' },
  { label: 'Outros' },
  { label: 'Não há' },
  { label: 'Não informado' },
];

export const especieList = [
  { label: 'Passageiro' },
  { label: 'Carga' },
  { label: 'Misto' },
  { label: 'Tração' },
  { label: 'Especial' },
  { label: 'Competição' },
  { label: 'Coleção' },
  { label: 'Outros' },
  { label: 'Não informado' },
];

export const categoriaList = [
  { label: 'Particular' },
  { label: 'Aluguel' },
  { label: 'Oficial' },
  { label: 'Representante Estrangeira' },
  { label: 'Aprendizagem' },
  { label: 'Fabricante' },
  { label: 'Experiência' },
  { label: 'Repres. Estrangeira' },
  { label: 'Delivery' },
  { label: 'App de transporte' },
  { label: 'Não informado' },
];

export const danificadoList = [
  { label: 'Danificado' },
  { label: 'Sem danos' },
  { label: 'Não informado' },
];

export const aluguelList = [
  { label: 'Não Se Aplica' },
  { label: 'Alternativo' },
  { label: 'Escolar' },
  { label: 'Fretamento' },
  { label: 'Moto-Taxi' },
  { label: 'Ônibus' },
  { label: 'Ônibus Intermunicipal'},
  { label: 'Ônibus Municipal'},
  { label: 'Taxi' },
  { label: 'Não informado' },
];

export const sexoList = [
  { label: 'Masculino' },
  { label: 'Feminino' },
  { label: 'Não informado' },
];

export const categoriaCondutorList = [
  { label: 'Não Habilitado' },
  { label: 'Inabilitado p/ Veículo' },
  { label: 'Sem Habilitação' },
  { label: 'Permissionado' },
  { label: 'Não Exigível' },
  { label: 'Não Apresentou CNH' },
  { label: 'A' },
  { label: 'B' },
  { label: 'C' },
  { label: 'D' },
  { label: 'E' },
  { label: 'AD' },
  { label: 'AB' },
  { label: 'AE' },
  { label: 'AC' },
  { label: 'Ciclomotor' },
  { label: 'Não informado' },
];

export const exameAlcolemiaList = [
  { label: 'IML' },
  { label: 'DETRAN' },
  { label: 'OUTROS' },
  { label: 'Não' },
  { label: 'Não informado' },
];

export const tipoDocumentoList = [
  { label: 'RG' },
  { label: 'CPF' },
  { label: 'Carteira de Trabalho' },
  { label: 'Outro' },
  { label: 'Não informado' },
]

export const situacaoCondutorList = [
  { label: 'Permaneceu no Local' },
  { label: 'Atendeu a Vítima' },
  { label: 'Evadiu-se' },
  { label: 'Socorrido' },
  { label: 'Detido' },
  { label: 'Não informado' },
];

export const encaminhamentoList = [
  { label: 'Alta' },
  { label: 'Ambulatório' },
  { label: 'Conselho Tutelar Criança e Adolescente' },
  { label: 'Exames periciais' },
  { label: 'IML' },
  { label: 'Segurança Pública' },
  { label: 'Serviço de Referência SMS' },
  { label: 'Outros' },
  { label: 'Não informado' },
];

export const posicaoPassageiroList = [
  { label: 'Na Frente' },
  { label: 'Atrás' },
  { label: 'Em Pé' },
  { label: 'No Compartimento de Carga' },
  { label: 'Não informado' },
];

export const evolucaoCasoList = [
  { label: 'Internação' },
  { label: 'Liberado com Orientação' },
  { label: 'Obito Durante o Atendimento' },
  { label: 'Recebido com Obito' },
  { label: 'Transferência' },
  { label: 'Outros' },
  { label: 'Não informado' },
];

export const tipoPessoaList = [
  { label: 'Condutor' },
  { label: 'Passageiro' },
  { label: 'Pedestre' },
  { label: 'Motociclista' },
  { label: 'Ciclista' },
  { label: 'Outros' },
  { label: 'Não informado' },
];

export const lesoesList = [
  { label: 'Cabeça' },
  { label: 'Face' },
  { label: 'Pescoço' },
  { label: 'Ombro Direito' },
  { label: 'Ombro Esquerdo' },
  { label: 'Torax' },
  { label: 'Abdomem' },
  { label: 'Braço Direito' },
  { label: 'Braço Esquerdo' },
  { label: 'Mão Direita' },
  { label: 'Mãe Esquerda' },
  { label: 'Genitália' },
  { label: 'Perna Direita' },
  { label: 'Perna Esquerda' },
  { label: 'Pé Direito' },
  { label: 'Pé Esquerdo' },
  { label: 'Crânio' },
  { label: 'Nuca' },
  { label: 'Costas' },
  { label: 'Coluna' },
  { label: 'Nádegas' },
  { label: 'Tronco' },
  { label: 'Membros Superiores' },
  { label: 'Membros Inferiores' },
  { label: 'Não informado' },
];

export const gravidadeLesaoList = [
  { label: 'Ileso' },
  { label: 'Leve' },
  { label: 'Moderado' },
  { label: 'Grave' },
  { label: 'Fatal' },
  { label: 'Não informado' },
];

export const perfilUsuarioList = [
  { label: 'Não informado' },
  { label: 'quatro_rodas' },
  { label: 'duas_rodas' },
  { label: 'Outros' },
];

// export const perfilUsuarioList = [
  // { label: 'Ciclista' },
  // { label: 'Pedestre' },
  // { label: 'Outros' },
  // { label: 'Não informado' },
  // { label: 'quatro_rodas' },
  // { label: 'duas_rodas' },
// ];
